/**
 * @prettier
 * @flow
 */
import type { Environment } from 'src/constants/Environment';
import { Environments } from 'src/constants/Environment';

export function terminalWebhookUrl(environment: Environment): string {
    switch (environment) {
        case Environments.LOCALHOST:
            return 'http://localhost:7071/api/posEmulator/webhook?code=vpcYDZ_0y1b5uKB-8FFCPis5OBtYpMtw266kmgIwLULTAzFuv7vuVw%3D%3D';
        case Environments.TEST:
            return 'https://api-terminal-test.azurewebsites.net/api/posEmulator/webhook?code=vpcYDZ_0y1b5uKB-8FFCPis5OBtYpMtw266kmgIwLULTAzFuv7vuVw%3D%3D';
        case Environments.PROD:
            return 'https://api-terminal.azurewebsites.net/api/posEmulator/webhook?code=Kc1Ip7llsCounOmnBaU0QXb8mSTZlTgP2yyyyfm3xlo2sAFfXUBulQ%3D%3D';
        default:
            throw new Error(`Invalid argument environment=${environment}`);
    }
}
